import React, { useEffect, useState } from 'react'
import { usePdfRoadSigns, useRoadSigns } from '../../zustand/requests'
import { Button, Card, Checkbox, Empty, FloatButton, Image, Tabs, Typography } from 'antd';
import { DeleteOutline } from 'antd-mobile-icons';
import { BASE_URL } from '../../constants/link';

const ListPart = ({ selected, setSelected, list, fav }) => {

    const makePDF = usePdfRoadSigns();

    return list?.length ?
        (
            <>
                {/* <Button>Generate PDF</Button> */}
                <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "10px", justifyContent: "center" }}>
                    {list?.map((sign, index) => {
                        const id = (sign.id);
                        return (

                            <div style={{ width: "200px" }}>
                                <Card
                                    onClick={() => {
                                        if (!selected.includes(id)) {
                                            setSelected([...selected, id]);
                                        } else {
                                            setSelected(selected.filter(item => item !== id));
                                        }
                                    }}
                                    actions={!fav ? false : [
                                        <DeleteOutline color='red'
                                            onClick={() => {
                                                setSelected(selected.filter(item => item !== id));
                                            }}
                                        />
                                    ]}

                                    size='small' key={index} style={{ width: "100%", height: "100%" }}>
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
                                        <div>
                                            <Image preview={false} src={sign.img} />
                                        </div>
                                        <br />
                                        <div>
                                            {fav ?
                                                <Typography.Text>{sign.text}</Typography.Text>
                                                :
                                                <Checkbox
                                                    // onChange={(e) => { }}
                                                    checked={
                                                        // true
                                                        selected.includes(id)
                                                    }
                                                >
                                                    <Typography.Text>{sign.text}</Typography.Text>
                                                </Checkbox>}
                                        </div>
                                    </div>

                                </Card>
                            </div>
                        )
                    })}
                </div>
                {/* {fav && <FloatButton
                    onClick={() => {
                        if (!makePDF.loading && !makePDF.success) {
                            makePDF.execute({
                                data: { list },
                                onSuccess: (res) => {
                                    const data = res.data;

                                    const fileName = data.fileName;
                                    window.open(`${BASE_URL}/road-signs/file/${fileName}`, "_blank");
                                    makePDF.clean()
                                }
                            })
                        }
                    }}
                    type='primary' description="Make PDF" shape="square" />} */}
            </>
        ) : (<Empty />)
}

function RoadSignsPage() {
    const signs = useRoadSigns();
    const [selected, setSelected] = useState([]);
    const makePDF = usePdfRoadSigns();

    const list = signs.data?.map((v, i) => ({ ...v, id: String(i) }));

    useEffect(() => {
        signs.execute();
    }, []);

    return (
        <>
            {/* <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "10px", justifyContent: "center" }}>
            {signs.data?.map((sign, index) => (
                <div style={{ width: "200px" }}>
                    <Card size='small' key={index} style={{ width: "100%", height: "100%" }}>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
                            <div>
                                <Image preview={false} src={sign.img} />
                            </div>
                            <br />
                            <div>
                                <Checkbox onChange={(e) => {
                                    if (e.target.checked) {
                                        setSelected([...selected, index]);
                                    } else {
                                        setSelected(selected.filter(item => item !== index));
                                    }
                                }
                                }
                                    checked={selected.includes(index)}
                                >
                                    <Typography.Text>{sign.text} {String(selected.includes(index))}</Typography.Text>
                                </Checkbox>
                            </div>
                        </div>

                    </Card>
                </div>
            ))}
        </div> */}
            <Tabs
                items={[
                    {
                        key: "1",
                        label: "Road Signs",
                        children: <ListPart selected={selected} setSelected={setSelected} list={list} />
                    },
                    {
                        key: "2",
                        label: "Selected",
                        children: <ListPart fav selected={selected} setSelected={setSelected} list={list?.filter((_, index) => selected.includes(_.id))} />
                    }
                ]}
            />
            {/* {fav && */}
            <FloatButton
                onClick={() => {
                    if (!makePDF.loading && !makePDF.success) {
                        makePDF.execute({
                            data: { list: list?.filter((_, index) => selected.includes(_.id)) },
                            onSuccess: (res) => {
                                const data = res.data;

                                const fileName = data.fileName;
                                window.open(`${BASE_URL}/road-signs/file/${fileName}`, "_blank");
                                makePDF.clean()
                            }
                        })
                    }
                }}
                type='primary' description="Make PDF" shape="square" />
            {/* } */}
        </>
    )
}

export default RoadSignsPage